export { default as translations } from './translations.json';
export const MAX_LEADS = 1000;
export const LEAD_STATUSES = ['new', 'contacted', 'converted', 'closed'];

/**
 * Validate lead form data.
 * @param {{ name, email, message }} data
 * @returns {Object} — { field: error }
 */
export const validateLead = ({ name, email, message }) => {
  const errors = {};
  if (!name?.trim()) errors.name = 'Name is required';
  if (!email?.trim()) errors.email = 'Email is required';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = 'Invalid email';
  if (!message?.trim()) errors.message = 'Message is required';
  return errors;
};
